import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../../SvgIcons/CreateIconComponent';

export type BuildingChurch1IconProps = CreateIconComponentProps;
export const BuildingChurch1Icon: React.FC<BuildingChurch1IconProps> = ({
  title = 'BuildingChurch1',
  viewBox = '0 0 24 24',
  ...rest
}) => (
  <CreateIconComponent title={title} viewBox={viewBox} {...rest} fill="none">
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M3 21h18M10 21v-4a2 2 0 1 1 4 0v4"
    />
    <path
      fill="currentColor"
      d="M5 21a1 1 0 1 0 2 0H5Zm2-7a1 1 0 1 0-2 0h2Zm-3.707 1.293a1 1 0 1 0 1.414 1.414l-1.414-1.414ZM12 8l.707-.707a1 1 0 0 0-1.414 0L12 8Zm7.293 8.707a1 1 0 0 0 1.414-1.414l-1.414 1.414ZM19 14a1 1 0 1 0-2 0h2Zm-2 7a1 1 0 1 0 2 0h-2ZM7 21v-7H5v7h2Zm-2.293-4.293 8-8-1.414-1.414-8 8 1.414 1.414Zm6.586-8 8 8 1.414-1.414-8-8-1.414 1.414ZM17 14v7h2v-7h-2Z"
    />
    <path
      fill="currentColor"
      d="M14.788 6.594a1 1 0 1 0-1.407-1.421l1.407 1.42Zm-2.786 1.351-.703.71a1 1 0 0 0 1.407 0l-.704-.71Zm-1.378-2.772a1 1 0 0 0-1.408 1.42l1.408-1.42ZM9.223 6.6a1 1 0 0 0 1.394-1.434L9.223 6.6Zm2.78-2.54-.803.597a1 1 0 0 0 1.602.004l-.8-.6Zm1.38 1.111a1 1 0 1 0 1.402 1.427l-1.401-1.427Zm-.002.002-2.082 2.062 1.407 1.42 2.082-2.061-1.407-1.421Zm-.675 2.062-2.082-2.062-1.408 1.42L11.3 8.657l1.407-1.421Zm-2.088-2.069a.388.388 0 0 1-.1-.393l-1.91-.594a2.388 2.388 0 0 0 .615 2.42l1.394-1.433Zm-.1-.393a.388.388 0 0 1 .305-.267l-.336-1.972a2.388 2.388 0 0 0-1.88 1.645l1.91.594Zm.305-.267a.388.388 0 0 1 .377.15l1.605-1.192a2.388 2.388 0 0 0-2.318-.93l.336 1.972Zm1.979.155a.388.388 0 0 1 .376-.15l.34-1.97a2.388 2.388 0 0 0-2.315.918l1.599 1.202Zm.376-.15a.388.388 0 0 1 .304.268l1.91-.597a2.388 2.388 0 0 0-1.874-1.64l-.34 1.97Zm.304.268a.388.388 0 0 1-.098.392l1.401 1.427c.64-.628.873-1.56.606-2.416l-1.909.597Z"
    />
  </CreateIconComponent>
);
